/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegistrationClosedRouteImport } from './routes/registration-closed'
import { Route as HomeRouteImport } from './routes/home'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as WorkspaceNameRouteRouteImport } from './routes/$workspaceName/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RegisterIndexRouteImport } from './routes/register/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LoginRedirectRouteImport } from './routes/login/redirect'
import { Route as AdminImpersonateRouteImport } from './routes/admin/impersonate'
import { Route as LoginDeviceRouteRouteImport } from './routes/login/device/route'
import { Route as WorkspaceNameEnvironmentRouteRouteImport } from './routes/$workspaceName/$environment/route'
import { Route as LoginDeviceIndexRouteImport } from './routes/login/device/index'
import { Route as LoginDeviceCompleteRouteImport } from './routes/login/device/complete'
import { Route as WorkspaceNameEnvironmentStorageRouteImport } from './routes/$workspaceName/$environment/storage'
import { Route as WorkspaceNameEnvironmentSchedulesRouteImport } from './routes/$workspaceName/$environment/schedules'
import { Route as WorkspaceNameEnvironmentRunsRouteImport } from './routes/$workspaceName/$environment/runs'
import { Route as WorkspaceNameEnvironmentOnboardingRouteImport } from './routes/$workspaceName/$environment/onboarding'
import { Route as WorkspaceNameEnvironmentHomeRouteImport } from './routes/$workspaceName/$environment/home'
import { Route as WorkspaceNameEnvironmentAlertHistoryRouteImport } from './routes/$workspaceName/$environment/alert-history'
import { Route as WorkspaceNameEnvironmentTeamSettingsRouteRouteImport } from './routes/$workspaceName/$environment/team-settings/route'
import { Route as WorkspaceNameEnvironmentOrganizationSettingsRouteRouteImport } from './routes/$workspaceName/$environment/organization-settings/route'
import { Route as WorkspaceNameEnvironmentAdminRouteRouteImport } from './routes/$workspaceName/$environment/admin/route'
import { Route as WorkspaceNameEnvironmentAccountSettingsRouteRouteImport } from './routes/$workspaceName/$environment/account-settings/route'
import { Route as WorkspaceNameEnvironmentAppsIndexRouteImport } from './routes/$workspaceName/$environment/apps/index'
import { Route as WorkspaceNameEnvironmentTeamSettingsWebhooksRouteImport } from './routes/$workspaceName/$environment/team-settings/webhooks'
import { Route as WorkspaceNameEnvironmentTeamSettingsSecretsRouteImport } from './routes/$workspaceName/$environment/team-settings/secrets'
import { Route as WorkspaceNameEnvironmentTeamSettingsRunnersRouteImport } from './routes/$workspaceName/$environment/team-settings/runners'
import { Route as WorkspaceNameEnvironmentTeamSettingsMembersRouteImport } from './routes/$workspaceName/$environment/team-settings/members'
import { Route as WorkspaceNameEnvironmentTeamSettingsGeneralRouteImport } from './routes/$workspaceName/$environment/team-settings/general'
import { Route as WorkspaceNameEnvironmentTeamSettingsEnvironmentsRouteImport } from './routes/$workspaceName/$environment/team-settings/environments'
import { Route as WorkspaceNameEnvironmentTeamSettingsCatalogsRouteImport } from './routes/$workspaceName/$environment/team-settings/catalogs'
import { Route as WorkspaceNameEnvironmentTeamSettingsApiKeysRouteImport } from './routes/$workspaceName/$environment/team-settings/api-keys'
import { Route as WorkspaceNameEnvironmentOrganizationSettingsUsageRouteImport } from './routes/$workspaceName/$environment/organization-settings/usage'
import { Route as WorkspaceNameEnvironmentOrganizationSettingsTeamsRouteImport } from './routes/$workspaceName/$environment/organization-settings/teams'
import { Route as WorkspaceNameEnvironmentOrganizationSettingsSlackConnectionsRouteImport } from './routes/$workspaceName/$environment/organization-settings/slack-connections'
import { Route as WorkspaceNameEnvironmentOrganizationSettingsGeneralRouteImport } from './routes/$workspaceName/$environment/organization-settings/general'
import { Route as WorkspaceNameEnvironmentAdminTestRouteImport } from './routes/$workspaceName/$environment/admin/test'
import { Route as WorkspaceNameEnvironmentAdminRunnersRouteImport } from './routes/$workspaceName/$environment/admin/runners'
import { Route as WorkspaceNameEnvironmentAdminPlansRouteImport } from './routes/$workspaceName/$environment/admin/plans'
import { Route as WorkspaceNameEnvironmentAdminOrganizationsRouteImport } from './routes/$workspaceName/$environment/admin/organizations'
import { Route as WorkspaceNameEnvironmentAdminMaintenanceJobsRouteImport } from './routes/$workspaceName/$environment/admin/maintenance-jobs'
import { Route as WorkspaceNameEnvironmentAdminHomeRouteImport } from './routes/$workspaceName/$environment/admin/home'
import { Route as WorkspaceNameEnvironmentAdminFeatureFlagsRouteImport } from './routes/$workspaceName/$environment/admin/feature-flags'
import { Route as WorkspaceNameEnvironmentAdminColorsRouteImport } from './routes/$workspaceName/$environment/admin/colors'
import { Route as WorkspaceNameEnvironmentAccountSettingsTeamsRouteImport } from './routes/$workspaceName/$environment/account-settings/teams'
import { Route as WorkspaceNameEnvironmentAccountSettingsSecurityRouteImport } from './routes/$workspaceName/$environment/account-settings/security'
import { Route as WorkspaceNameEnvironmentAccountSettingsProfileRouteImport } from './routes/$workspaceName/$environment/account-settings/profile'
import { Route as WorkspaceNameEnvironmentAccountSettingsAlertsRouteImport } from './routes/$workspaceName/$environment/account-settings/alerts'
import { Route as WorkspaceNameEnvironmentTeamSettingsServiceAccountsIndexRouteImport } from './routes/$workspaceName/$environment/team-settings/service-accounts.index'
import { Route as WorkspaceNameEnvironmentAppsNameIndexRouteImport } from './routes/$workspaceName/$environment/apps/$name/index'
import { Route as WorkspaceNameEnvironmentAdminUsersIndexRouteImport } from './routes/$workspaceName/$environment/admin/users/index'
import { Route as WorkspaceNameEnvironmentAdminRunsIndexRouteImport } from './routes/$workspaceName/$environment/admin/runs/index'
import { Route as WorkspaceNameEnvironmentAdminOrganizationsIndexRouteImport } from './routes/$workspaceName/$environment/admin/organizations/index'
import { Route as WorkspaceNameEnvironmentTeamSettingsServiceAccountsSaIdOrNameRouteImport } from './routes/$workspaceName/$environment/team-settings/service-accounts.$saIdOrName'
import { Route as WorkspaceNameEnvironmentAdminUsersUserIdRouteImport } from './routes/$workspaceName/$environment/admin/users/$userId'
import { Route as WorkspaceNameEnvironmentAdminRunsRunIdRouteImport } from './routes/$workspaceName/$environment/admin/runs/$runId'
import { Route as WorkspaceNameEnvironmentAdminOrganizationsOrganizationIdRouteImport } from './routes/$workspaceName/$environment/admin/organizations/$organizationId'
import { Route as WorkspaceNameEnvironmentAppsNameRunsSeqRouteImport } from './routes/$workspaceName/$environment/apps/$name/runs/$seq'
import { Route as WorkspaceNameEnvironmentAdminOrganizationsIdUsageRouteImport } from './routes/$workspaceName/$environment/admin/organizations/$id/usage'

const RegistrationClosedRoute = RegistrationClosedRouteImport.update({
  id: '/registration-closed',
  path: '/registration-closed',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceNameRouteRoute = WorkspaceNameRouteRouteImport.update({
  id: '/$workspaceName',
  path: '/$workspaceName',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterIndexRoute = RegisterIndexRouteImport.update({
  id: '/register/',
  path: '/register/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRedirectRoute = LoginRedirectRouteImport.update({
  id: '/login/redirect',
  path: '/login/redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminImpersonateRoute = AdminImpersonateRouteImport.update({
  id: '/admin/impersonate',
  path: '/admin/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginDeviceRouteRoute = LoginDeviceRouteRouteImport.update({
  id: '/login/device',
  path: '/login/device',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceNameEnvironmentRouteRoute =
  WorkspaceNameEnvironmentRouteRouteImport.update({
    id: '/$environment',
    path: '/$environment',
    getParentRoute: () => WorkspaceNameRouteRoute,
  } as any)
const LoginDeviceIndexRoute = LoginDeviceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginDeviceRouteRoute,
} as any)
const LoginDeviceCompleteRoute = LoginDeviceCompleteRouteImport.update({
  id: '/complete',
  path: '/complete',
  getParentRoute: () => LoginDeviceRouteRoute,
} as any)
const WorkspaceNameEnvironmentStorageRoute =
  WorkspaceNameEnvironmentStorageRouteImport.update({
    id: '/storage',
    path: '/storage',
    getParentRoute: () => WorkspaceNameEnvironmentRouteRoute,
  } as any)
const WorkspaceNameEnvironmentSchedulesRoute =
  WorkspaceNameEnvironmentSchedulesRouteImport.update({
    id: '/schedules',
    path: '/schedules',
    getParentRoute: () => WorkspaceNameEnvironmentRouteRoute,
  } as any)
const WorkspaceNameEnvironmentRunsRoute =
  WorkspaceNameEnvironmentRunsRouteImport.update({
    id: '/runs',
    path: '/runs',
    getParentRoute: () => WorkspaceNameEnvironmentRouteRoute,
  } as any)
const WorkspaceNameEnvironmentOnboardingRoute =
  WorkspaceNameEnvironmentOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => WorkspaceNameEnvironmentRouteRoute,
  } as any)
const WorkspaceNameEnvironmentHomeRoute =
  WorkspaceNameEnvironmentHomeRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => WorkspaceNameEnvironmentRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAlertHistoryRoute =
  WorkspaceNameEnvironmentAlertHistoryRouteImport.update({
    id: '/alert-history',
    path: '/alert-history',
    getParentRoute: () => WorkspaceNameEnvironmentRouteRoute,
  } as any)
const WorkspaceNameEnvironmentTeamSettingsRouteRoute =
  WorkspaceNameEnvironmentTeamSettingsRouteRouteImport.update({
    id: '/team-settings',
    path: '/team-settings',
    getParentRoute: () => WorkspaceNameEnvironmentRouteRoute,
  } as any)
const WorkspaceNameEnvironmentOrganizationSettingsRouteRoute =
  WorkspaceNameEnvironmentOrganizationSettingsRouteRouteImport.update({
    id: '/organization-settings',
    path: '/organization-settings',
    getParentRoute: () => WorkspaceNameEnvironmentRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminRouteRoute =
  WorkspaceNameEnvironmentAdminRouteRouteImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => WorkspaceNameEnvironmentRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAccountSettingsRouteRoute =
  WorkspaceNameEnvironmentAccountSettingsRouteRouteImport.update({
    id: '/account-settings',
    path: '/account-settings',
    getParentRoute: () => WorkspaceNameEnvironmentRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAppsIndexRoute =
  WorkspaceNameEnvironmentAppsIndexRouteImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => WorkspaceNameEnvironmentRouteRoute,
  } as any)
const WorkspaceNameEnvironmentTeamSettingsWebhooksRoute =
  WorkspaceNameEnvironmentTeamSettingsWebhooksRouteImport.update({
    id: '/webhooks',
    path: '/webhooks',
    getParentRoute: () => WorkspaceNameEnvironmentTeamSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentTeamSettingsSecretsRoute =
  WorkspaceNameEnvironmentTeamSettingsSecretsRouteImport.update({
    id: '/secrets',
    path: '/secrets',
    getParentRoute: () => WorkspaceNameEnvironmentTeamSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentTeamSettingsRunnersRoute =
  WorkspaceNameEnvironmentTeamSettingsRunnersRouteImport.update({
    id: '/runners',
    path: '/runners',
    getParentRoute: () => WorkspaceNameEnvironmentTeamSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentTeamSettingsMembersRoute =
  WorkspaceNameEnvironmentTeamSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => WorkspaceNameEnvironmentTeamSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentTeamSettingsGeneralRoute =
  WorkspaceNameEnvironmentTeamSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => WorkspaceNameEnvironmentTeamSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentTeamSettingsEnvironmentsRoute =
  WorkspaceNameEnvironmentTeamSettingsEnvironmentsRouteImport.update({
    id: '/environments',
    path: '/environments',
    getParentRoute: () => WorkspaceNameEnvironmentTeamSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentTeamSettingsCatalogsRoute =
  WorkspaceNameEnvironmentTeamSettingsCatalogsRouteImport.update({
    id: '/catalogs',
    path: '/catalogs',
    getParentRoute: () => WorkspaceNameEnvironmentTeamSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentTeamSettingsApiKeysRoute =
  WorkspaceNameEnvironmentTeamSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => WorkspaceNameEnvironmentTeamSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentOrganizationSettingsUsageRoute =
  WorkspaceNameEnvironmentOrganizationSettingsUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () =>
      WorkspaceNameEnvironmentOrganizationSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentOrganizationSettingsTeamsRoute =
  WorkspaceNameEnvironmentOrganizationSettingsTeamsRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () =>
      WorkspaceNameEnvironmentOrganizationSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentOrganizationSettingsSlackConnectionsRoute =
  WorkspaceNameEnvironmentOrganizationSettingsSlackConnectionsRouteImport.update(
    {
      id: '/slack-connections',
      path: '/slack-connections',
      getParentRoute: () =>
        WorkspaceNameEnvironmentOrganizationSettingsRouteRoute,
    } as any,
  )
const WorkspaceNameEnvironmentOrganizationSettingsGeneralRoute =
  WorkspaceNameEnvironmentOrganizationSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () =>
      WorkspaceNameEnvironmentOrganizationSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminTestRoute =
  WorkspaceNameEnvironmentAdminTestRouteImport.update({
    id: '/test',
    path: '/test',
    getParentRoute: () => WorkspaceNameEnvironmentAdminRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminRunnersRoute =
  WorkspaceNameEnvironmentAdminRunnersRouteImport.update({
    id: '/runners',
    path: '/runners',
    getParentRoute: () => WorkspaceNameEnvironmentAdminRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminPlansRoute =
  WorkspaceNameEnvironmentAdminPlansRouteImport.update({
    id: '/plans',
    path: '/plans',
    getParentRoute: () => WorkspaceNameEnvironmentAdminRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminOrganizationsRoute =
  WorkspaceNameEnvironmentAdminOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => WorkspaceNameEnvironmentAdminRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminMaintenanceJobsRoute =
  WorkspaceNameEnvironmentAdminMaintenanceJobsRouteImport.update({
    id: '/maintenance-jobs',
    path: '/maintenance-jobs',
    getParentRoute: () => WorkspaceNameEnvironmentAdminRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminHomeRoute =
  WorkspaceNameEnvironmentAdminHomeRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => WorkspaceNameEnvironmentAdminRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminFeatureFlagsRoute =
  WorkspaceNameEnvironmentAdminFeatureFlagsRouteImport.update({
    id: '/feature-flags',
    path: '/feature-flags',
    getParentRoute: () => WorkspaceNameEnvironmentAdminRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminColorsRoute =
  WorkspaceNameEnvironmentAdminColorsRouteImport.update({
    id: '/colors',
    path: '/colors',
    getParentRoute: () => WorkspaceNameEnvironmentAdminRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAccountSettingsTeamsRoute =
  WorkspaceNameEnvironmentAccountSettingsTeamsRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => WorkspaceNameEnvironmentAccountSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAccountSettingsSecurityRoute =
  WorkspaceNameEnvironmentAccountSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => WorkspaceNameEnvironmentAccountSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAccountSettingsProfileRoute =
  WorkspaceNameEnvironmentAccountSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => WorkspaceNameEnvironmentAccountSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAccountSettingsAlertsRoute =
  WorkspaceNameEnvironmentAccountSettingsAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => WorkspaceNameEnvironmentAccountSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentTeamSettingsServiceAccountsIndexRoute =
  WorkspaceNameEnvironmentTeamSettingsServiceAccountsIndexRouteImport.update({
    id: '/service-accounts/',
    path: '/service-accounts/',
    getParentRoute: () => WorkspaceNameEnvironmentTeamSettingsRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAppsNameIndexRoute =
  WorkspaceNameEnvironmentAppsNameIndexRouteImport.update({
    id: '/apps/$name/',
    path: '/apps/$name/',
    getParentRoute: () => WorkspaceNameEnvironmentRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminUsersIndexRoute =
  WorkspaceNameEnvironmentAdminUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => WorkspaceNameEnvironmentAdminRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminRunsIndexRoute =
  WorkspaceNameEnvironmentAdminRunsIndexRouteImport.update({
    id: '/runs/',
    path: '/runs/',
    getParentRoute: () => WorkspaceNameEnvironmentAdminRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminOrganizationsIndexRoute =
  WorkspaceNameEnvironmentAdminOrganizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceNameEnvironmentAdminOrganizationsRoute,
  } as any)
const WorkspaceNameEnvironmentTeamSettingsServiceAccountsSaIdOrNameRoute =
  WorkspaceNameEnvironmentTeamSettingsServiceAccountsSaIdOrNameRouteImport.update(
    {
      id: '/service-accounts/$saIdOrName',
      path: '/service-accounts/$saIdOrName',
      getParentRoute: () => WorkspaceNameEnvironmentTeamSettingsRouteRoute,
    } as any,
  )
const WorkspaceNameEnvironmentAdminUsersUserIdRoute =
  WorkspaceNameEnvironmentAdminUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => WorkspaceNameEnvironmentAdminRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminRunsRunIdRoute =
  WorkspaceNameEnvironmentAdminRunsRunIdRouteImport.update({
    id: '/runs/$runId',
    path: '/runs/$runId',
    getParentRoute: () => WorkspaceNameEnvironmentAdminRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminOrganizationsOrganizationIdRoute =
  WorkspaceNameEnvironmentAdminOrganizationsOrganizationIdRouteImport.update({
    id: '/$organizationId',
    path: '/$organizationId',
    getParentRoute: () => WorkspaceNameEnvironmentAdminOrganizationsRoute,
  } as any)
const WorkspaceNameEnvironmentAppsNameRunsSeqRoute =
  WorkspaceNameEnvironmentAppsNameRunsSeqRouteImport.update({
    id: '/apps/$name/runs/$seq',
    path: '/apps/$name/runs/$seq',
    getParentRoute: () => WorkspaceNameEnvironmentRouteRoute,
  } as any)
const WorkspaceNameEnvironmentAdminOrganizationsIdUsageRoute =
  WorkspaceNameEnvironmentAdminOrganizationsIdUsageRouteImport.update({
    id: '/$id/usage',
    path: '/$id/usage',
    getParentRoute: () => WorkspaceNameEnvironmentAdminOrganizationsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$workspaceName': typeof WorkspaceNameRouteRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/home': typeof HomeRoute
  '/registration-closed': typeof RegistrationClosedRoute
  '/$workspaceName/$environment': typeof WorkspaceNameEnvironmentRouteRouteWithChildren
  '/login/device': typeof LoginDeviceRouteRouteWithChildren
  '/admin/impersonate': typeof AdminImpersonateRoute
  '/login/redirect': typeof LoginRedirectRoute
  '/login/': typeof LoginIndexRoute
  '/register/': typeof RegisterIndexRoute
  '/$workspaceName/$environment/account-settings': typeof WorkspaceNameEnvironmentAccountSettingsRouteRouteWithChildren
  '/$workspaceName/$environment/admin': typeof WorkspaceNameEnvironmentAdminRouteRouteWithChildren
  '/$workspaceName/$environment/organization-settings': typeof WorkspaceNameEnvironmentOrganizationSettingsRouteRouteWithChildren
  '/$workspaceName/$environment/team-settings': typeof WorkspaceNameEnvironmentTeamSettingsRouteRouteWithChildren
  '/$workspaceName/$environment/alert-history': typeof WorkspaceNameEnvironmentAlertHistoryRoute
  '/$workspaceName/$environment/home': typeof WorkspaceNameEnvironmentHomeRoute
  '/$workspaceName/$environment/onboarding': typeof WorkspaceNameEnvironmentOnboardingRoute
  '/$workspaceName/$environment/runs': typeof WorkspaceNameEnvironmentRunsRoute
  '/$workspaceName/$environment/schedules': typeof WorkspaceNameEnvironmentSchedulesRoute
  '/$workspaceName/$environment/storage': typeof WorkspaceNameEnvironmentStorageRoute
  '/login/device/complete': typeof LoginDeviceCompleteRoute
  '/login/device/': typeof LoginDeviceIndexRoute
  '/$workspaceName/$environment/account-settings/alerts': typeof WorkspaceNameEnvironmentAccountSettingsAlertsRoute
  '/$workspaceName/$environment/account-settings/profile': typeof WorkspaceNameEnvironmentAccountSettingsProfileRoute
  '/$workspaceName/$environment/account-settings/security': typeof WorkspaceNameEnvironmentAccountSettingsSecurityRoute
  '/$workspaceName/$environment/account-settings/teams': typeof WorkspaceNameEnvironmentAccountSettingsTeamsRoute
  '/$workspaceName/$environment/admin/colors': typeof WorkspaceNameEnvironmentAdminColorsRoute
  '/$workspaceName/$environment/admin/feature-flags': typeof WorkspaceNameEnvironmentAdminFeatureFlagsRoute
  '/$workspaceName/$environment/admin/home': typeof WorkspaceNameEnvironmentAdminHomeRoute
  '/$workspaceName/$environment/admin/maintenance-jobs': typeof WorkspaceNameEnvironmentAdminMaintenanceJobsRoute
  '/$workspaceName/$environment/admin/organizations': typeof WorkspaceNameEnvironmentAdminOrganizationsRouteWithChildren
  '/$workspaceName/$environment/admin/plans': typeof WorkspaceNameEnvironmentAdminPlansRoute
  '/$workspaceName/$environment/admin/runners': typeof WorkspaceNameEnvironmentAdminRunnersRoute
  '/$workspaceName/$environment/admin/test': typeof WorkspaceNameEnvironmentAdminTestRoute
  '/$workspaceName/$environment/organization-settings/general': typeof WorkspaceNameEnvironmentOrganizationSettingsGeneralRoute
  '/$workspaceName/$environment/organization-settings/slack-connections': typeof WorkspaceNameEnvironmentOrganizationSettingsSlackConnectionsRoute
  '/$workspaceName/$environment/organization-settings/teams': typeof WorkspaceNameEnvironmentOrganizationSettingsTeamsRoute
  '/$workspaceName/$environment/organization-settings/usage': typeof WorkspaceNameEnvironmentOrganizationSettingsUsageRoute
  '/$workspaceName/$environment/team-settings/api-keys': typeof WorkspaceNameEnvironmentTeamSettingsApiKeysRoute
  '/$workspaceName/$environment/team-settings/catalogs': typeof WorkspaceNameEnvironmentTeamSettingsCatalogsRoute
  '/$workspaceName/$environment/team-settings/environments': typeof WorkspaceNameEnvironmentTeamSettingsEnvironmentsRoute
  '/$workspaceName/$environment/team-settings/general': typeof WorkspaceNameEnvironmentTeamSettingsGeneralRoute
  '/$workspaceName/$environment/team-settings/members': typeof WorkspaceNameEnvironmentTeamSettingsMembersRoute
  '/$workspaceName/$environment/team-settings/runners': typeof WorkspaceNameEnvironmentTeamSettingsRunnersRoute
  '/$workspaceName/$environment/team-settings/secrets': typeof WorkspaceNameEnvironmentTeamSettingsSecretsRoute
  '/$workspaceName/$environment/team-settings/webhooks': typeof WorkspaceNameEnvironmentTeamSettingsWebhooksRoute
  '/$workspaceName/$environment/apps/': typeof WorkspaceNameEnvironmentAppsIndexRoute
  '/$workspaceName/$environment/admin/organizations/$organizationId': typeof WorkspaceNameEnvironmentAdminOrganizationsOrganizationIdRoute
  '/$workspaceName/$environment/admin/runs/$runId': typeof WorkspaceNameEnvironmentAdminRunsRunIdRoute
  '/$workspaceName/$environment/admin/users/$userId': typeof WorkspaceNameEnvironmentAdminUsersUserIdRoute
  '/$workspaceName/$environment/team-settings/service-accounts/$saIdOrName': typeof WorkspaceNameEnvironmentTeamSettingsServiceAccountsSaIdOrNameRoute
  '/$workspaceName/$environment/admin/organizations/': typeof WorkspaceNameEnvironmentAdminOrganizationsIndexRoute
  '/$workspaceName/$environment/admin/runs/': typeof WorkspaceNameEnvironmentAdminRunsIndexRoute
  '/$workspaceName/$environment/admin/users/': typeof WorkspaceNameEnvironmentAdminUsersIndexRoute
  '/$workspaceName/$environment/apps/$name/': typeof WorkspaceNameEnvironmentAppsNameIndexRoute
  '/$workspaceName/$environment/team-settings/service-accounts/': typeof WorkspaceNameEnvironmentTeamSettingsServiceAccountsIndexRoute
  '/$workspaceName/$environment/admin/organizations/$id/usage': typeof WorkspaceNameEnvironmentAdminOrganizationsIdUsageRoute
  '/$workspaceName/$environment/apps/$name/runs/$seq': typeof WorkspaceNameEnvironmentAppsNameRunsSeqRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$workspaceName': typeof WorkspaceNameRouteRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/home': typeof HomeRoute
  '/registration-closed': typeof RegistrationClosedRoute
  '/$workspaceName/$environment': typeof WorkspaceNameEnvironmentRouteRouteWithChildren
  '/admin/impersonate': typeof AdminImpersonateRoute
  '/login/redirect': typeof LoginRedirectRoute
  '/login': typeof LoginIndexRoute
  '/register': typeof RegisterIndexRoute
  '/$workspaceName/$environment/account-settings': typeof WorkspaceNameEnvironmentAccountSettingsRouteRouteWithChildren
  '/$workspaceName/$environment/admin': typeof WorkspaceNameEnvironmentAdminRouteRouteWithChildren
  '/$workspaceName/$environment/organization-settings': typeof WorkspaceNameEnvironmentOrganizationSettingsRouteRouteWithChildren
  '/$workspaceName/$environment/team-settings': typeof WorkspaceNameEnvironmentTeamSettingsRouteRouteWithChildren
  '/$workspaceName/$environment/alert-history': typeof WorkspaceNameEnvironmentAlertHistoryRoute
  '/$workspaceName/$environment/home': typeof WorkspaceNameEnvironmentHomeRoute
  '/$workspaceName/$environment/onboarding': typeof WorkspaceNameEnvironmentOnboardingRoute
  '/$workspaceName/$environment/runs': typeof WorkspaceNameEnvironmentRunsRoute
  '/$workspaceName/$environment/schedules': typeof WorkspaceNameEnvironmentSchedulesRoute
  '/$workspaceName/$environment/storage': typeof WorkspaceNameEnvironmentStorageRoute
  '/login/device/complete': typeof LoginDeviceCompleteRoute
  '/login/device': typeof LoginDeviceIndexRoute
  '/$workspaceName/$environment/account-settings/alerts': typeof WorkspaceNameEnvironmentAccountSettingsAlertsRoute
  '/$workspaceName/$environment/account-settings/profile': typeof WorkspaceNameEnvironmentAccountSettingsProfileRoute
  '/$workspaceName/$environment/account-settings/security': typeof WorkspaceNameEnvironmentAccountSettingsSecurityRoute
  '/$workspaceName/$environment/account-settings/teams': typeof WorkspaceNameEnvironmentAccountSettingsTeamsRoute
  '/$workspaceName/$environment/admin/colors': typeof WorkspaceNameEnvironmentAdminColorsRoute
  '/$workspaceName/$environment/admin/feature-flags': typeof WorkspaceNameEnvironmentAdminFeatureFlagsRoute
  '/$workspaceName/$environment/admin/home': typeof WorkspaceNameEnvironmentAdminHomeRoute
  '/$workspaceName/$environment/admin/maintenance-jobs': typeof WorkspaceNameEnvironmentAdminMaintenanceJobsRoute
  '/$workspaceName/$environment/admin/plans': typeof WorkspaceNameEnvironmentAdminPlansRoute
  '/$workspaceName/$environment/admin/runners': typeof WorkspaceNameEnvironmentAdminRunnersRoute
  '/$workspaceName/$environment/admin/test': typeof WorkspaceNameEnvironmentAdminTestRoute
  '/$workspaceName/$environment/organization-settings/general': typeof WorkspaceNameEnvironmentOrganizationSettingsGeneralRoute
  '/$workspaceName/$environment/organization-settings/slack-connections': typeof WorkspaceNameEnvironmentOrganizationSettingsSlackConnectionsRoute
  '/$workspaceName/$environment/organization-settings/teams': typeof WorkspaceNameEnvironmentOrganizationSettingsTeamsRoute
  '/$workspaceName/$environment/organization-settings/usage': typeof WorkspaceNameEnvironmentOrganizationSettingsUsageRoute
  '/$workspaceName/$environment/team-settings/api-keys': typeof WorkspaceNameEnvironmentTeamSettingsApiKeysRoute
  '/$workspaceName/$environment/team-settings/catalogs': typeof WorkspaceNameEnvironmentTeamSettingsCatalogsRoute
  '/$workspaceName/$environment/team-settings/environments': typeof WorkspaceNameEnvironmentTeamSettingsEnvironmentsRoute
  '/$workspaceName/$environment/team-settings/general': typeof WorkspaceNameEnvironmentTeamSettingsGeneralRoute
  '/$workspaceName/$environment/team-settings/members': typeof WorkspaceNameEnvironmentTeamSettingsMembersRoute
  '/$workspaceName/$environment/team-settings/runners': typeof WorkspaceNameEnvironmentTeamSettingsRunnersRoute
  '/$workspaceName/$environment/team-settings/secrets': typeof WorkspaceNameEnvironmentTeamSettingsSecretsRoute
  '/$workspaceName/$environment/team-settings/webhooks': typeof WorkspaceNameEnvironmentTeamSettingsWebhooksRoute
  '/$workspaceName/$environment/apps': typeof WorkspaceNameEnvironmentAppsIndexRoute
  '/$workspaceName/$environment/admin/organizations/$organizationId': typeof WorkspaceNameEnvironmentAdminOrganizationsOrganizationIdRoute
  '/$workspaceName/$environment/admin/runs/$runId': typeof WorkspaceNameEnvironmentAdminRunsRunIdRoute
  '/$workspaceName/$environment/admin/users/$userId': typeof WorkspaceNameEnvironmentAdminUsersUserIdRoute
  '/$workspaceName/$environment/team-settings/service-accounts/$saIdOrName': typeof WorkspaceNameEnvironmentTeamSettingsServiceAccountsSaIdOrNameRoute
  '/$workspaceName/$environment/admin/organizations': typeof WorkspaceNameEnvironmentAdminOrganizationsIndexRoute
  '/$workspaceName/$environment/admin/runs': typeof WorkspaceNameEnvironmentAdminRunsIndexRoute
  '/$workspaceName/$environment/admin/users': typeof WorkspaceNameEnvironmentAdminUsersIndexRoute
  '/$workspaceName/$environment/apps/$name': typeof WorkspaceNameEnvironmentAppsNameIndexRoute
  '/$workspaceName/$environment/team-settings/service-accounts': typeof WorkspaceNameEnvironmentTeamSettingsServiceAccountsIndexRoute
  '/$workspaceName/$environment/admin/organizations/$id/usage': typeof WorkspaceNameEnvironmentAdminOrganizationsIdUsageRoute
  '/$workspaceName/$environment/apps/$name/runs/$seq': typeof WorkspaceNameEnvironmentAppsNameRunsSeqRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$workspaceName': typeof WorkspaceNameRouteRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/home': typeof HomeRoute
  '/registration-closed': typeof RegistrationClosedRoute
  '/$workspaceName/$environment': typeof WorkspaceNameEnvironmentRouteRouteWithChildren
  '/login/device': typeof LoginDeviceRouteRouteWithChildren
  '/admin/impersonate': typeof AdminImpersonateRoute
  '/login/redirect': typeof LoginRedirectRoute
  '/login/': typeof LoginIndexRoute
  '/register/': typeof RegisterIndexRoute
  '/$workspaceName/$environment/account-settings': typeof WorkspaceNameEnvironmentAccountSettingsRouteRouteWithChildren
  '/$workspaceName/$environment/admin': typeof WorkspaceNameEnvironmentAdminRouteRouteWithChildren
  '/$workspaceName/$environment/organization-settings': typeof WorkspaceNameEnvironmentOrganizationSettingsRouteRouteWithChildren
  '/$workspaceName/$environment/team-settings': typeof WorkspaceNameEnvironmentTeamSettingsRouteRouteWithChildren
  '/$workspaceName/$environment/alert-history': typeof WorkspaceNameEnvironmentAlertHistoryRoute
  '/$workspaceName/$environment/home': typeof WorkspaceNameEnvironmentHomeRoute
  '/$workspaceName/$environment/onboarding': typeof WorkspaceNameEnvironmentOnboardingRoute
  '/$workspaceName/$environment/runs': typeof WorkspaceNameEnvironmentRunsRoute
  '/$workspaceName/$environment/schedules': typeof WorkspaceNameEnvironmentSchedulesRoute
  '/$workspaceName/$environment/storage': typeof WorkspaceNameEnvironmentStorageRoute
  '/login/device/complete': typeof LoginDeviceCompleteRoute
  '/login/device/': typeof LoginDeviceIndexRoute
  '/$workspaceName/$environment/account-settings/alerts': typeof WorkspaceNameEnvironmentAccountSettingsAlertsRoute
  '/$workspaceName/$environment/account-settings/profile': typeof WorkspaceNameEnvironmentAccountSettingsProfileRoute
  '/$workspaceName/$environment/account-settings/security': typeof WorkspaceNameEnvironmentAccountSettingsSecurityRoute
  '/$workspaceName/$environment/account-settings/teams': typeof WorkspaceNameEnvironmentAccountSettingsTeamsRoute
  '/$workspaceName/$environment/admin/colors': typeof WorkspaceNameEnvironmentAdminColorsRoute
  '/$workspaceName/$environment/admin/feature-flags': typeof WorkspaceNameEnvironmentAdminFeatureFlagsRoute
  '/$workspaceName/$environment/admin/home': typeof WorkspaceNameEnvironmentAdminHomeRoute
  '/$workspaceName/$environment/admin/maintenance-jobs': typeof WorkspaceNameEnvironmentAdminMaintenanceJobsRoute
  '/$workspaceName/$environment/admin/organizations': typeof WorkspaceNameEnvironmentAdminOrganizationsRouteWithChildren
  '/$workspaceName/$environment/admin/plans': typeof WorkspaceNameEnvironmentAdminPlansRoute
  '/$workspaceName/$environment/admin/runners': typeof WorkspaceNameEnvironmentAdminRunnersRoute
  '/$workspaceName/$environment/admin/test': typeof WorkspaceNameEnvironmentAdminTestRoute
  '/$workspaceName/$environment/organization-settings/general': typeof WorkspaceNameEnvironmentOrganizationSettingsGeneralRoute
  '/$workspaceName/$environment/organization-settings/slack-connections': typeof WorkspaceNameEnvironmentOrganizationSettingsSlackConnectionsRoute
  '/$workspaceName/$environment/organization-settings/teams': typeof WorkspaceNameEnvironmentOrganizationSettingsTeamsRoute
  '/$workspaceName/$environment/organization-settings/usage': typeof WorkspaceNameEnvironmentOrganizationSettingsUsageRoute
  '/$workspaceName/$environment/team-settings/api-keys': typeof WorkspaceNameEnvironmentTeamSettingsApiKeysRoute
  '/$workspaceName/$environment/team-settings/catalogs': typeof WorkspaceNameEnvironmentTeamSettingsCatalogsRoute
  '/$workspaceName/$environment/team-settings/environments': typeof WorkspaceNameEnvironmentTeamSettingsEnvironmentsRoute
  '/$workspaceName/$environment/team-settings/general': typeof WorkspaceNameEnvironmentTeamSettingsGeneralRoute
  '/$workspaceName/$environment/team-settings/members': typeof WorkspaceNameEnvironmentTeamSettingsMembersRoute
  '/$workspaceName/$environment/team-settings/runners': typeof WorkspaceNameEnvironmentTeamSettingsRunnersRoute
  '/$workspaceName/$environment/team-settings/secrets': typeof WorkspaceNameEnvironmentTeamSettingsSecretsRoute
  '/$workspaceName/$environment/team-settings/webhooks': typeof WorkspaceNameEnvironmentTeamSettingsWebhooksRoute
  '/$workspaceName/$environment/apps/': typeof WorkspaceNameEnvironmentAppsIndexRoute
  '/$workspaceName/$environment/admin/organizations/$organizationId': typeof WorkspaceNameEnvironmentAdminOrganizationsOrganizationIdRoute
  '/$workspaceName/$environment/admin/runs/$runId': typeof WorkspaceNameEnvironmentAdminRunsRunIdRoute
  '/$workspaceName/$environment/admin/users/$userId': typeof WorkspaceNameEnvironmentAdminUsersUserIdRoute
  '/$workspaceName/$environment/team-settings/service-accounts/$saIdOrName': typeof WorkspaceNameEnvironmentTeamSettingsServiceAccountsSaIdOrNameRoute
  '/$workspaceName/$environment/admin/organizations/': typeof WorkspaceNameEnvironmentAdminOrganizationsIndexRoute
  '/$workspaceName/$environment/admin/runs/': typeof WorkspaceNameEnvironmentAdminRunsIndexRoute
  '/$workspaceName/$environment/admin/users/': typeof WorkspaceNameEnvironmentAdminUsersIndexRoute
  '/$workspaceName/$environment/apps/$name/': typeof WorkspaceNameEnvironmentAppsNameIndexRoute
  '/$workspaceName/$environment/team-settings/service-accounts/': typeof WorkspaceNameEnvironmentTeamSettingsServiceAccountsIndexRoute
  '/$workspaceName/$environment/admin/organizations/$id/usage': typeof WorkspaceNameEnvironmentAdminOrganizationsIdUsageRoute
  '/$workspaceName/$environment/apps/$name/runs/$seq': typeof WorkspaceNameEnvironmentAppsNameRunsSeqRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$workspaceName'
    | '/accept-invitation'
    | '/home'
    | '/registration-closed'
    | '/$workspaceName/$environment'
    | '/login/device'
    | '/admin/impersonate'
    | '/login/redirect'
    | '/login/'
    | '/register/'
    | '/$workspaceName/$environment/account-settings'
    | '/$workspaceName/$environment/admin'
    | '/$workspaceName/$environment/organization-settings'
    | '/$workspaceName/$environment/team-settings'
    | '/$workspaceName/$environment/alert-history'
    | '/$workspaceName/$environment/home'
    | '/$workspaceName/$environment/onboarding'
    | '/$workspaceName/$environment/runs'
    | '/$workspaceName/$environment/schedules'
    | '/$workspaceName/$environment/storage'
    | '/login/device/complete'
    | '/login/device/'
    | '/$workspaceName/$environment/account-settings/alerts'
    | '/$workspaceName/$environment/account-settings/profile'
    | '/$workspaceName/$environment/account-settings/security'
    | '/$workspaceName/$environment/account-settings/teams'
    | '/$workspaceName/$environment/admin/colors'
    | '/$workspaceName/$environment/admin/feature-flags'
    | '/$workspaceName/$environment/admin/home'
    | '/$workspaceName/$environment/admin/maintenance-jobs'
    | '/$workspaceName/$environment/admin/organizations'
    | '/$workspaceName/$environment/admin/plans'
    | '/$workspaceName/$environment/admin/runners'
    | '/$workspaceName/$environment/admin/test'
    | '/$workspaceName/$environment/organization-settings/general'
    | '/$workspaceName/$environment/organization-settings/slack-connections'
    | '/$workspaceName/$environment/organization-settings/teams'
    | '/$workspaceName/$environment/organization-settings/usage'
    | '/$workspaceName/$environment/team-settings/api-keys'
    | '/$workspaceName/$environment/team-settings/catalogs'
    | '/$workspaceName/$environment/team-settings/environments'
    | '/$workspaceName/$environment/team-settings/general'
    | '/$workspaceName/$environment/team-settings/members'
    | '/$workspaceName/$environment/team-settings/runners'
    | '/$workspaceName/$environment/team-settings/secrets'
    | '/$workspaceName/$environment/team-settings/webhooks'
    | '/$workspaceName/$environment/apps/'
    | '/$workspaceName/$environment/admin/organizations/$organizationId'
    | '/$workspaceName/$environment/admin/runs/$runId'
    | '/$workspaceName/$environment/admin/users/$userId'
    | '/$workspaceName/$environment/team-settings/service-accounts/$saIdOrName'
    | '/$workspaceName/$environment/admin/organizations/'
    | '/$workspaceName/$environment/admin/runs/'
    | '/$workspaceName/$environment/admin/users/'
    | '/$workspaceName/$environment/apps/$name/'
    | '/$workspaceName/$environment/team-settings/service-accounts/'
    | '/$workspaceName/$environment/admin/organizations/$id/usage'
    | '/$workspaceName/$environment/apps/$name/runs/$seq'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$workspaceName'
    | '/accept-invitation'
    | '/home'
    | '/registration-closed'
    | '/$workspaceName/$environment'
    | '/admin/impersonate'
    | '/login/redirect'
    | '/login'
    | '/register'
    | '/$workspaceName/$environment/account-settings'
    | '/$workspaceName/$environment/admin'
    | '/$workspaceName/$environment/organization-settings'
    | '/$workspaceName/$environment/team-settings'
    | '/$workspaceName/$environment/alert-history'
    | '/$workspaceName/$environment/home'
    | '/$workspaceName/$environment/onboarding'
    | '/$workspaceName/$environment/runs'
    | '/$workspaceName/$environment/schedules'
    | '/$workspaceName/$environment/storage'
    | '/login/device/complete'
    | '/login/device'
    | '/$workspaceName/$environment/account-settings/alerts'
    | '/$workspaceName/$environment/account-settings/profile'
    | '/$workspaceName/$environment/account-settings/security'
    | '/$workspaceName/$environment/account-settings/teams'
    | '/$workspaceName/$environment/admin/colors'
    | '/$workspaceName/$environment/admin/feature-flags'
    | '/$workspaceName/$environment/admin/home'
    | '/$workspaceName/$environment/admin/maintenance-jobs'
    | '/$workspaceName/$environment/admin/plans'
    | '/$workspaceName/$environment/admin/runners'
    | '/$workspaceName/$environment/admin/test'
    | '/$workspaceName/$environment/organization-settings/general'
    | '/$workspaceName/$environment/organization-settings/slack-connections'
    | '/$workspaceName/$environment/organization-settings/teams'
    | '/$workspaceName/$environment/organization-settings/usage'
    | '/$workspaceName/$environment/team-settings/api-keys'
    | '/$workspaceName/$environment/team-settings/catalogs'
    | '/$workspaceName/$environment/team-settings/environments'
    | '/$workspaceName/$environment/team-settings/general'
    | '/$workspaceName/$environment/team-settings/members'
    | '/$workspaceName/$environment/team-settings/runners'
    | '/$workspaceName/$environment/team-settings/secrets'
    | '/$workspaceName/$environment/team-settings/webhooks'
    | '/$workspaceName/$environment/apps'
    | '/$workspaceName/$environment/admin/organizations/$organizationId'
    | '/$workspaceName/$environment/admin/runs/$runId'
    | '/$workspaceName/$environment/admin/users/$userId'
    | '/$workspaceName/$environment/team-settings/service-accounts/$saIdOrName'
    | '/$workspaceName/$environment/admin/organizations'
    | '/$workspaceName/$environment/admin/runs'
    | '/$workspaceName/$environment/admin/users'
    | '/$workspaceName/$environment/apps/$name'
    | '/$workspaceName/$environment/team-settings/service-accounts'
    | '/$workspaceName/$environment/admin/organizations/$id/usage'
    | '/$workspaceName/$environment/apps/$name/runs/$seq'
  id:
    | '__root__'
    | '/'
    | '/$workspaceName'
    | '/accept-invitation'
    | '/home'
    | '/registration-closed'
    | '/$workspaceName/$environment'
    | '/login/device'
    | '/admin/impersonate'
    | '/login/redirect'
    | '/login/'
    | '/register/'
    | '/$workspaceName/$environment/account-settings'
    | '/$workspaceName/$environment/admin'
    | '/$workspaceName/$environment/organization-settings'
    | '/$workspaceName/$environment/team-settings'
    | '/$workspaceName/$environment/alert-history'
    | '/$workspaceName/$environment/home'
    | '/$workspaceName/$environment/onboarding'
    | '/$workspaceName/$environment/runs'
    | '/$workspaceName/$environment/schedules'
    | '/$workspaceName/$environment/storage'
    | '/login/device/complete'
    | '/login/device/'
    | '/$workspaceName/$environment/account-settings/alerts'
    | '/$workspaceName/$environment/account-settings/profile'
    | '/$workspaceName/$environment/account-settings/security'
    | '/$workspaceName/$environment/account-settings/teams'
    | '/$workspaceName/$environment/admin/colors'
    | '/$workspaceName/$environment/admin/feature-flags'
    | '/$workspaceName/$environment/admin/home'
    | '/$workspaceName/$environment/admin/maintenance-jobs'
    | '/$workspaceName/$environment/admin/organizations'
    | '/$workspaceName/$environment/admin/plans'
    | '/$workspaceName/$environment/admin/runners'
    | '/$workspaceName/$environment/admin/test'
    | '/$workspaceName/$environment/organization-settings/general'
    | '/$workspaceName/$environment/organization-settings/slack-connections'
    | '/$workspaceName/$environment/organization-settings/teams'
    | '/$workspaceName/$environment/organization-settings/usage'
    | '/$workspaceName/$environment/team-settings/api-keys'
    | '/$workspaceName/$environment/team-settings/catalogs'
    | '/$workspaceName/$environment/team-settings/environments'
    | '/$workspaceName/$environment/team-settings/general'
    | '/$workspaceName/$environment/team-settings/members'
    | '/$workspaceName/$environment/team-settings/runners'
    | '/$workspaceName/$environment/team-settings/secrets'
    | '/$workspaceName/$environment/team-settings/webhooks'
    | '/$workspaceName/$environment/apps/'
    | '/$workspaceName/$environment/admin/organizations/$organizationId'
    | '/$workspaceName/$environment/admin/runs/$runId'
    | '/$workspaceName/$environment/admin/users/$userId'
    | '/$workspaceName/$environment/team-settings/service-accounts/$saIdOrName'
    | '/$workspaceName/$environment/admin/organizations/'
    | '/$workspaceName/$environment/admin/runs/'
    | '/$workspaceName/$environment/admin/users/'
    | '/$workspaceName/$environment/apps/$name/'
    | '/$workspaceName/$environment/team-settings/service-accounts/'
    | '/$workspaceName/$environment/admin/organizations/$id/usage'
    | '/$workspaceName/$environment/apps/$name/runs/$seq'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  WorkspaceNameRouteRoute: typeof WorkspaceNameRouteRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  HomeRoute: typeof HomeRoute
  RegistrationClosedRoute: typeof RegistrationClosedRoute
  LoginDeviceRouteRoute: typeof LoginDeviceRouteRouteWithChildren
  AdminImpersonateRoute: typeof AdminImpersonateRoute
  LoginRedirectRoute: typeof LoginRedirectRoute
  LoginIndexRoute: typeof LoginIndexRoute
  RegisterIndexRoute: typeof RegisterIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/registration-closed': {
      id: '/registration-closed'
      path: '/registration-closed'
      fullPath: '/registration-closed'
      preLoaderRoute: typeof RegistrationClosedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$workspaceName': {
      id: '/$workspaceName'
      path: '/$workspaceName'
      fullPath: '/$workspaceName'
      preLoaderRoute: typeof WorkspaceNameRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register/': {
      id: '/register/'
      path: '/register'
      fullPath: '/register/'
      preLoaderRoute: typeof RegisterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/redirect': {
      id: '/login/redirect'
      path: '/login/redirect'
      fullPath: '/login/redirect'
      preLoaderRoute: typeof LoginRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/impersonate': {
      id: '/admin/impersonate'
      path: '/admin/impersonate'
      fullPath: '/admin/impersonate'
      preLoaderRoute: typeof AdminImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/device': {
      id: '/login/device'
      path: '/login/device'
      fullPath: '/login/device'
      preLoaderRoute: typeof LoginDeviceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$workspaceName/$environment': {
      id: '/$workspaceName/$environment'
      path: '/$environment'
      fullPath: '/$workspaceName/$environment'
      preLoaderRoute: typeof WorkspaceNameEnvironmentRouteRouteImport
      parentRoute: typeof WorkspaceNameRouteRoute
    }
    '/login/device/': {
      id: '/login/device/'
      path: '/'
      fullPath: '/login/device/'
      preLoaderRoute: typeof LoginDeviceIndexRouteImport
      parentRoute: typeof LoginDeviceRouteRoute
    }
    '/login/device/complete': {
      id: '/login/device/complete'
      path: '/complete'
      fullPath: '/login/device/complete'
      preLoaderRoute: typeof LoginDeviceCompleteRouteImport
      parentRoute: typeof LoginDeviceRouteRoute
    }
    '/$workspaceName/$environment/storage': {
      id: '/$workspaceName/$environment/storage'
      path: '/storage'
      fullPath: '/$workspaceName/$environment/storage'
      preLoaderRoute: typeof WorkspaceNameEnvironmentStorageRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentRouteRoute
    }
    '/$workspaceName/$environment/schedules': {
      id: '/$workspaceName/$environment/schedules'
      path: '/schedules'
      fullPath: '/$workspaceName/$environment/schedules'
      preLoaderRoute: typeof WorkspaceNameEnvironmentSchedulesRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentRouteRoute
    }
    '/$workspaceName/$environment/runs': {
      id: '/$workspaceName/$environment/runs'
      path: '/runs'
      fullPath: '/$workspaceName/$environment/runs'
      preLoaderRoute: typeof WorkspaceNameEnvironmentRunsRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentRouteRoute
    }
    '/$workspaceName/$environment/onboarding': {
      id: '/$workspaceName/$environment/onboarding'
      path: '/onboarding'
      fullPath: '/$workspaceName/$environment/onboarding'
      preLoaderRoute: typeof WorkspaceNameEnvironmentOnboardingRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentRouteRoute
    }
    '/$workspaceName/$environment/home': {
      id: '/$workspaceName/$environment/home'
      path: '/home'
      fullPath: '/$workspaceName/$environment/home'
      preLoaderRoute: typeof WorkspaceNameEnvironmentHomeRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentRouteRoute
    }
    '/$workspaceName/$environment/alert-history': {
      id: '/$workspaceName/$environment/alert-history'
      path: '/alert-history'
      fullPath: '/$workspaceName/$environment/alert-history'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAlertHistoryRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentRouteRoute
    }
    '/$workspaceName/$environment/team-settings': {
      id: '/$workspaceName/$environment/team-settings'
      path: '/team-settings'
      fullPath: '/$workspaceName/$environment/team-settings'
      preLoaderRoute: typeof WorkspaceNameEnvironmentTeamSettingsRouteRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentRouteRoute
    }
    '/$workspaceName/$environment/organization-settings': {
      id: '/$workspaceName/$environment/organization-settings'
      path: '/organization-settings'
      fullPath: '/$workspaceName/$environment/organization-settings'
      preLoaderRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsRouteRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentRouteRoute
    }
    '/$workspaceName/$environment/admin': {
      id: '/$workspaceName/$environment/admin'
      path: '/admin'
      fullPath: '/$workspaceName/$environment/admin'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminRouteRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentRouteRoute
    }
    '/$workspaceName/$environment/account-settings': {
      id: '/$workspaceName/$environment/account-settings'
      path: '/account-settings'
      fullPath: '/$workspaceName/$environment/account-settings'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAccountSettingsRouteRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentRouteRoute
    }
    '/$workspaceName/$environment/apps/': {
      id: '/$workspaceName/$environment/apps/'
      path: '/apps'
      fullPath: '/$workspaceName/$environment/apps/'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAppsIndexRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentRouteRoute
    }
    '/$workspaceName/$environment/team-settings/webhooks': {
      id: '/$workspaceName/$environment/team-settings/webhooks'
      path: '/webhooks'
      fullPath: '/$workspaceName/$environment/team-settings/webhooks'
      preLoaderRoute: typeof WorkspaceNameEnvironmentTeamSettingsWebhooksRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentTeamSettingsRouteRoute
    }
    '/$workspaceName/$environment/team-settings/secrets': {
      id: '/$workspaceName/$environment/team-settings/secrets'
      path: '/secrets'
      fullPath: '/$workspaceName/$environment/team-settings/secrets'
      preLoaderRoute: typeof WorkspaceNameEnvironmentTeamSettingsSecretsRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentTeamSettingsRouteRoute
    }
    '/$workspaceName/$environment/team-settings/runners': {
      id: '/$workspaceName/$environment/team-settings/runners'
      path: '/runners'
      fullPath: '/$workspaceName/$environment/team-settings/runners'
      preLoaderRoute: typeof WorkspaceNameEnvironmentTeamSettingsRunnersRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentTeamSettingsRouteRoute
    }
    '/$workspaceName/$environment/team-settings/members': {
      id: '/$workspaceName/$environment/team-settings/members'
      path: '/members'
      fullPath: '/$workspaceName/$environment/team-settings/members'
      preLoaderRoute: typeof WorkspaceNameEnvironmentTeamSettingsMembersRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentTeamSettingsRouteRoute
    }
    '/$workspaceName/$environment/team-settings/general': {
      id: '/$workspaceName/$environment/team-settings/general'
      path: '/general'
      fullPath: '/$workspaceName/$environment/team-settings/general'
      preLoaderRoute: typeof WorkspaceNameEnvironmentTeamSettingsGeneralRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentTeamSettingsRouteRoute
    }
    '/$workspaceName/$environment/team-settings/environments': {
      id: '/$workspaceName/$environment/team-settings/environments'
      path: '/environments'
      fullPath: '/$workspaceName/$environment/team-settings/environments'
      preLoaderRoute: typeof WorkspaceNameEnvironmentTeamSettingsEnvironmentsRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentTeamSettingsRouteRoute
    }
    '/$workspaceName/$environment/team-settings/catalogs': {
      id: '/$workspaceName/$environment/team-settings/catalogs'
      path: '/catalogs'
      fullPath: '/$workspaceName/$environment/team-settings/catalogs'
      preLoaderRoute: typeof WorkspaceNameEnvironmentTeamSettingsCatalogsRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentTeamSettingsRouteRoute
    }
    '/$workspaceName/$environment/team-settings/api-keys': {
      id: '/$workspaceName/$environment/team-settings/api-keys'
      path: '/api-keys'
      fullPath: '/$workspaceName/$environment/team-settings/api-keys'
      preLoaderRoute: typeof WorkspaceNameEnvironmentTeamSettingsApiKeysRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentTeamSettingsRouteRoute
    }
    '/$workspaceName/$environment/organization-settings/usage': {
      id: '/$workspaceName/$environment/organization-settings/usage'
      path: '/usage'
      fullPath: '/$workspaceName/$environment/organization-settings/usage'
      preLoaderRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsUsageRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsRouteRoute
    }
    '/$workspaceName/$environment/organization-settings/teams': {
      id: '/$workspaceName/$environment/organization-settings/teams'
      path: '/teams'
      fullPath: '/$workspaceName/$environment/organization-settings/teams'
      preLoaderRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsTeamsRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsRouteRoute
    }
    '/$workspaceName/$environment/organization-settings/slack-connections': {
      id: '/$workspaceName/$environment/organization-settings/slack-connections'
      path: '/slack-connections'
      fullPath: '/$workspaceName/$environment/organization-settings/slack-connections'
      preLoaderRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsSlackConnectionsRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsRouteRoute
    }
    '/$workspaceName/$environment/organization-settings/general': {
      id: '/$workspaceName/$environment/organization-settings/general'
      path: '/general'
      fullPath: '/$workspaceName/$environment/organization-settings/general'
      preLoaderRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsGeneralRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsRouteRoute
    }
    '/$workspaceName/$environment/admin/test': {
      id: '/$workspaceName/$environment/admin/test'
      path: '/test'
      fullPath: '/$workspaceName/$environment/admin/test'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminTestRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminRouteRoute
    }
    '/$workspaceName/$environment/admin/runners': {
      id: '/$workspaceName/$environment/admin/runners'
      path: '/runners'
      fullPath: '/$workspaceName/$environment/admin/runners'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminRunnersRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminRouteRoute
    }
    '/$workspaceName/$environment/admin/plans': {
      id: '/$workspaceName/$environment/admin/plans'
      path: '/plans'
      fullPath: '/$workspaceName/$environment/admin/plans'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminPlansRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminRouteRoute
    }
    '/$workspaceName/$environment/admin/organizations': {
      id: '/$workspaceName/$environment/admin/organizations'
      path: '/organizations'
      fullPath: '/$workspaceName/$environment/admin/organizations'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminOrganizationsRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminRouteRoute
    }
    '/$workspaceName/$environment/admin/maintenance-jobs': {
      id: '/$workspaceName/$environment/admin/maintenance-jobs'
      path: '/maintenance-jobs'
      fullPath: '/$workspaceName/$environment/admin/maintenance-jobs'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminMaintenanceJobsRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminRouteRoute
    }
    '/$workspaceName/$environment/admin/home': {
      id: '/$workspaceName/$environment/admin/home'
      path: '/home'
      fullPath: '/$workspaceName/$environment/admin/home'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminHomeRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminRouteRoute
    }
    '/$workspaceName/$environment/admin/feature-flags': {
      id: '/$workspaceName/$environment/admin/feature-flags'
      path: '/feature-flags'
      fullPath: '/$workspaceName/$environment/admin/feature-flags'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminFeatureFlagsRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminRouteRoute
    }
    '/$workspaceName/$environment/admin/colors': {
      id: '/$workspaceName/$environment/admin/colors'
      path: '/colors'
      fullPath: '/$workspaceName/$environment/admin/colors'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminColorsRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminRouteRoute
    }
    '/$workspaceName/$environment/account-settings/teams': {
      id: '/$workspaceName/$environment/account-settings/teams'
      path: '/teams'
      fullPath: '/$workspaceName/$environment/account-settings/teams'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAccountSettingsTeamsRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAccountSettingsRouteRoute
    }
    '/$workspaceName/$environment/account-settings/security': {
      id: '/$workspaceName/$environment/account-settings/security'
      path: '/security'
      fullPath: '/$workspaceName/$environment/account-settings/security'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAccountSettingsSecurityRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAccountSettingsRouteRoute
    }
    '/$workspaceName/$environment/account-settings/profile': {
      id: '/$workspaceName/$environment/account-settings/profile'
      path: '/profile'
      fullPath: '/$workspaceName/$environment/account-settings/profile'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAccountSettingsProfileRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAccountSettingsRouteRoute
    }
    '/$workspaceName/$environment/account-settings/alerts': {
      id: '/$workspaceName/$environment/account-settings/alerts'
      path: '/alerts'
      fullPath: '/$workspaceName/$environment/account-settings/alerts'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAccountSettingsAlertsRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAccountSettingsRouteRoute
    }
    '/$workspaceName/$environment/team-settings/service-accounts/': {
      id: '/$workspaceName/$environment/team-settings/service-accounts/'
      path: '/service-accounts'
      fullPath: '/$workspaceName/$environment/team-settings/service-accounts/'
      preLoaderRoute: typeof WorkspaceNameEnvironmentTeamSettingsServiceAccountsIndexRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentTeamSettingsRouteRoute
    }
    '/$workspaceName/$environment/apps/$name/': {
      id: '/$workspaceName/$environment/apps/$name/'
      path: '/apps/$name'
      fullPath: '/$workspaceName/$environment/apps/$name/'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAppsNameIndexRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentRouteRoute
    }
    '/$workspaceName/$environment/admin/users/': {
      id: '/$workspaceName/$environment/admin/users/'
      path: '/users'
      fullPath: '/$workspaceName/$environment/admin/users/'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminUsersIndexRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminRouteRoute
    }
    '/$workspaceName/$environment/admin/runs/': {
      id: '/$workspaceName/$environment/admin/runs/'
      path: '/runs'
      fullPath: '/$workspaceName/$environment/admin/runs/'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminRunsIndexRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminRouteRoute
    }
    '/$workspaceName/$environment/admin/organizations/': {
      id: '/$workspaceName/$environment/admin/organizations/'
      path: '/'
      fullPath: '/$workspaceName/$environment/admin/organizations/'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminOrganizationsIndexRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminOrganizationsRoute
    }
    '/$workspaceName/$environment/team-settings/service-accounts/$saIdOrName': {
      id: '/$workspaceName/$environment/team-settings/service-accounts/$saIdOrName'
      path: '/service-accounts/$saIdOrName'
      fullPath: '/$workspaceName/$environment/team-settings/service-accounts/$saIdOrName'
      preLoaderRoute: typeof WorkspaceNameEnvironmentTeamSettingsServiceAccountsSaIdOrNameRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentTeamSettingsRouteRoute
    }
    '/$workspaceName/$environment/admin/users/$userId': {
      id: '/$workspaceName/$environment/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/$workspaceName/$environment/admin/users/$userId'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminUsersUserIdRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminRouteRoute
    }
    '/$workspaceName/$environment/admin/runs/$runId': {
      id: '/$workspaceName/$environment/admin/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/$workspaceName/$environment/admin/runs/$runId'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminRunsRunIdRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminRouteRoute
    }
    '/$workspaceName/$environment/admin/organizations/$organizationId': {
      id: '/$workspaceName/$environment/admin/organizations/$organizationId'
      path: '/$organizationId'
      fullPath: '/$workspaceName/$environment/admin/organizations/$organizationId'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminOrganizationsOrganizationIdRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminOrganizationsRoute
    }
    '/$workspaceName/$environment/apps/$name/runs/$seq': {
      id: '/$workspaceName/$environment/apps/$name/runs/$seq'
      path: '/apps/$name/runs/$seq'
      fullPath: '/$workspaceName/$environment/apps/$name/runs/$seq'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAppsNameRunsSeqRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentRouteRoute
    }
    '/$workspaceName/$environment/admin/organizations/$id/usage': {
      id: '/$workspaceName/$environment/admin/organizations/$id/usage'
      path: '/$id/usage'
      fullPath: '/$workspaceName/$environment/admin/organizations/$id/usage'
      preLoaderRoute: typeof WorkspaceNameEnvironmentAdminOrganizationsIdUsageRouteImport
      parentRoute: typeof WorkspaceNameEnvironmentAdminOrganizationsRoute
    }
  }
}

interface WorkspaceNameEnvironmentAccountSettingsRouteRouteChildren {
  WorkspaceNameEnvironmentAccountSettingsAlertsRoute: typeof WorkspaceNameEnvironmentAccountSettingsAlertsRoute
  WorkspaceNameEnvironmentAccountSettingsProfileRoute: typeof WorkspaceNameEnvironmentAccountSettingsProfileRoute
  WorkspaceNameEnvironmentAccountSettingsSecurityRoute: typeof WorkspaceNameEnvironmentAccountSettingsSecurityRoute
  WorkspaceNameEnvironmentAccountSettingsTeamsRoute: typeof WorkspaceNameEnvironmentAccountSettingsTeamsRoute
}

const WorkspaceNameEnvironmentAccountSettingsRouteRouteChildren: WorkspaceNameEnvironmentAccountSettingsRouteRouteChildren =
  {
    WorkspaceNameEnvironmentAccountSettingsAlertsRoute:
      WorkspaceNameEnvironmentAccountSettingsAlertsRoute,
    WorkspaceNameEnvironmentAccountSettingsProfileRoute:
      WorkspaceNameEnvironmentAccountSettingsProfileRoute,
    WorkspaceNameEnvironmentAccountSettingsSecurityRoute:
      WorkspaceNameEnvironmentAccountSettingsSecurityRoute,
    WorkspaceNameEnvironmentAccountSettingsTeamsRoute:
      WorkspaceNameEnvironmentAccountSettingsTeamsRoute,
  }

const WorkspaceNameEnvironmentAccountSettingsRouteRouteWithChildren =
  WorkspaceNameEnvironmentAccountSettingsRouteRoute._addFileChildren(
    WorkspaceNameEnvironmentAccountSettingsRouteRouteChildren,
  )

interface WorkspaceNameEnvironmentAdminOrganizationsRouteChildren {
  WorkspaceNameEnvironmentAdminOrganizationsOrganizationIdRoute: typeof WorkspaceNameEnvironmentAdminOrganizationsOrganizationIdRoute
  WorkspaceNameEnvironmentAdminOrganizationsIndexRoute: typeof WorkspaceNameEnvironmentAdminOrganizationsIndexRoute
  WorkspaceNameEnvironmentAdminOrganizationsIdUsageRoute: typeof WorkspaceNameEnvironmentAdminOrganizationsIdUsageRoute
}

const WorkspaceNameEnvironmentAdminOrganizationsRouteChildren: WorkspaceNameEnvironmentAdminOrganizationsRouteChildren =
  {
    WorkspaceNameEnvironmentAdminOrganizationsOrganizationIdRoute:
      WorkspaceNameEnvironmentAdminOrganizationsOrganizationIdRoute,
    WorkspaceNameEnvironmentAdminOrganizationsIndexRoute:
      WorkspaceNameEnvironmentAdminOrganizationsIndexRoute,
    WorkspaceNameEnvironmentAdminOrganizationsIdUsageRoute:
      WorkspaceNameEnvironmentAdminOrganizationsIdUsageRoute,
  }

const WorkspaceNameEnvironmentAdminOrganizationsRouteWithChildren =
  WorkspaceNameEnvironmentAdminOrganizationsRoute._addFileChildren(
    WorkspaceNameEnvironmentAdminOrganizationsRouteChildren,
  )

interface WorkspaceNameEnvironmentAdminRouteRouteChildren {
  WorkspaceNameEnvironmentAdminColorsRoute: typeof WorkspaceNameEnvironmentAdminColorsRoute
  WorkspaceNameEnvironmentAdminFeatureFlagsRoute: typeof WorkspaceNameEnvironmentAdminFeatureFlagsRoute
  WorkspaceNameEnvironmentAdminHomeRoute: typeof WorkspaceNameEnvironmentAdminHomeRoute
  WorkspaceNameEnvironmentAdminMaintenanceJobsRoute: typeof WorkspaceNameEnvironmentAdminMaintenanceJobsRoute
  WorkspaceNameEnvironmentAdminOrganizationsRoute: typeof WorkspaceNameEnvironmentAdminOrganizationsRouteWithChildren
  WorkspaceNameEnvironmentAdminPlansRoute: typeof WorkspaceNameEnvironmentAdminPlansRoute
  WorkspaceNameEnvironmentAdminRunnersRoute: typeof WorkspaceNameEnvironmentAdminRunnersRoute
  WorkspaceNameEnvironmentAdminTestRoute: typeof WorkspaceNameEnvironmentAdminTestRoute
  WorkspaceNameEnvironmentAdminRunsRunIdRoute: typeof WorkspaceNameEnvironmentAdminRunsRunIdRoute
  WorkspaceNameEnvironmentAdminUsersUserIdRoute: typeof WorkspaceNameEnvironmentAdminUsersUserIdRoute
  WorkspaceNameEnvironmentAdminRunsIndexRoute: typeof WorkspaceNameEnvironmentAdminRunsIndexRoute
  WorkspaceNameEnvironmentAdminUsersIndexRoute: typeof WorkspaceNameEnvironmentAdminUsersIndexRoute
}

const WorkspaceNameEnvironmentAdminRouteRouteChildren: WorkspaceNameEnvironmentAdminRouteRouteChildren =
  {
    WorkspaceNameEnvironmentAdminColorsRoute:
      WorkspaceNameEnvironmentAdminColorsRoute,
    WorkspaceNameEnvironmentAdminFeatureFlagsRoute:
      WorkspaceNameEnvironmentAdminFeatureFlagsRoute,
    WorkspaceNameEnvironmentAdminHomeRoute:
      WorkspaceNameEnvironmentAdminHomeRoute,
    WorkspaceNameEnvironmentAdminMaintenanceJobsRoute:
      WorkspaceNameEnvironmentAdminMaintenanceJobsRoute,
    WorkspaceNameEnvironmentAdminOrganizationsRoute:
      WorkspaceNameEnvironmentAdminOrganizationsRouteWithChildren,
    WorkspaceNameEnvironmentAdminPlansRoute:
      WorkspaceNameEnvironmentAdminPlansRoute,
    WorkspaceNameEnvironmentAdminRunnersRoute:
      WorkspaceNameEnvironmentAdminRunnersRoute,
    WorkspaceNameEnvironmentAdminTestRoute:
      WorkspaceNameEnvironmentAdminTestRoute,
    WorkspaceNameEnvironmentAdminRunsRunIdRoute:
      WorkspaceNameEnvironmentAdminRunsRunIdRoute,
    WorkspaceNameEnvironmentAdminUsersUserIdRoute:
      WorkspaceNameEnvironmentAdminUsersUserIdRoute,
    WorkspaceNameEnvironmentAdminRunsIndexRoute:
      WorkspaceNameEnvironmentAdminRunsIndexRoute,
    WorkspaceNameEnvironmentAdminUsersIndexRoute:
      WorkspaceNameEnvironmentAdminUsersIndexRoute,
  }

const WorkspaceNameEnvironmentAdminRouteRouteWithChildren =
  WorkspaceNameEnvironmentAdminRouteRoute._addFileChildren(
    WorkspaceNameEnvironmentAdminRouteRouteChildren,
  )

interface WorkspaceNameEnvironmentOrganizationSettingsRouteRouteChildren {
  WorkspaceNameEnvironmentOrganizationSettingsGeneralRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsGeneralRoute
  WorkspaceNameEnvironmentOrganizationSettingsSlackConnectionsRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsSlackConnectionsRoute
  WorkspaceNameEnvironmentOrganizationSettingsTeamsRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsTeamsRoute
  WorkspaceNameEnvironmentOrganizationSettingsUsageRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsUsageRoute
}

const WorkspaceNameEnvironmentOrganizationSettingsRouteRouteChildren: WorkspaceNameEnvironmentOrganizationSettingsRouteRouteChildren =
  {
    WorkspaceNameEnvironmentOrganizationSettingsGeneralRoute:
      WorkspaceNameEnvironmentOrganizationSettingsGeneralRoute,
    WorkspaceNameEnvironmentOrganizationSettingsSlackConnectionsRoute:
      WorkspaceNameEnvironmentOrganizationSettingsSlackConnectionsRoute,
    WorkspaceNameEnvironmentOrganizationSettingsTeamsRoute:
      WorkspaceNameEnvironmentOrganizationSettingsTeamsRoute,
    WorkspaceNameEnvironmentOrganizationSettingsUsageRoute:
      WorkspaceNameEnvironmentOrganizationSettingsUsageRoute,
  }

const WorkspaceNameEnvironmentOrganizationSettingsRouteRouteWithChildren =
  WorkspaceNameEnvironmentOrganizationSettingsRouteRoute._addFileChildren(
    WorkspaceNameEnvironmentOrganizationSettingsRouteRouteChildren,
  )

interface WorkspaceNameEnvironmentTeamSettingsRouteRouteChildren {
  WorkspaceNameEnvironmentTeamSettingsApiKeysRoute: typeof WorkspaceNameEnvironmentTeamSettingsApiKeysRoute
  WorkspaceNameEnvironmentTeamSettingsCatalogsRoute: typeof WorkspaceNameEnvironmentTeamSettingsCatalogsRoute
  WorkspaceNameEnvironmentTeamSettingsEnvironmentsRoute: typeof WorkspaceNameEnvironmentTeamSettingsEnvironmentsRoute
  WorkspaceNameEnvironmentTeamSettingsGeneralRoute: typeof WorkspaceNameEnvironmentTeamSettingsGeneralRoute
  WorkspaceNameEnvironmentTeamSettingsMembersRoute: typeof WorkspaceNameEnvironmentTeamSettingsMembersRoute
  WorkspaceNameEnvironmentTeamSettingsRunnersRoute: typeof WorkspaceNameEnvironmentTeamSettingsRunnersRoute
  WorkspaceNameEnvironmentTeamSettingsSecretsRoute: typeof WorkspaceNameEnvironmentTeamSettingsSecretsRoute
  WorkspaceNameEnvironmentTeamSettingsWebhooksRoute: typeof WorkspaceNameEnvironmentTeamSettingsWebhooksRoute
  WorkspaceNameEnvironmentTeamSettingsServiceAccountsSaIdOrNameRoute: typeof WorkspaceNameEnvironmentTeamSettingsServiceAccountsSaIdOrNameRoute
  WorkspaceNameEnvironmentTeamSettingsServiceAccountsIndexRoute: typeof WorkspaceNameEnvironmentTeamSettingsServiceAccountsIndexRoute
}

const WorkspaceNameEnvironmentTeamSettingsRouteRouteChildren: WorkspaceNameEnvironmentTeamSettingsRouteRouteChildren =
  {
    WorkspaceNameEnvironmentTeamSettingsApiKeysRoute:
      WorkspaceNameEnvironmentTeamSettingsApiKeysRoute,
    WorkspaceNameEnvironmentTeamSettingsCatalogsRoute:
      WorkspaceNameEnvironmentTeamSettingsCatalogsRoute,
    WorkspaceNameEnvironmentTeamSettingsEnvironmentsRoute:
      WorkspaceNameEnvironmentTeamSettingsEnvironmentsRoute,
    WorkspaceNameEnvironmentTeamSettingsGeneralRoute:
      WorkspaceNameEnvironmentTeamSettingsGeneralRoute,
    WorkspaceNameEnvironmentTeamSettingsMembersRoute:
      WorkspaceNameEnvironmentTeamSettingsMembersRoute,
    WorkspaceNameEnvironmentTeamSettingsRunnersRoute:
      WorkspaceNameEnvironmentTeamSettingsRunnersRoute,
    WorkspaceNameEnvironmentTeamSettingsSecretsRoute:
      WorkspaceNameEnvironmentTeamSettingsSecretsRoute,
    WorkspaceNameEnvironmentTeamSettingsWebhooksRoute:
      WorkspaceNameEnvironmentTeamSettingsWebhooksRoute,
    WorkspaceNameEnvironmentTeamSettingsServiceAccountsSaIdOrNameRoute:
      WorkspaceNameEnvironmentTeamSettingsServiceAccountsSaIdOrNameRoute,
    WorkspaceNameEnvironmentTeamSettingsServiceAccountsIndexRoute:
      WorkspaceNameEnvironmentTeamSettingsServiceAccountsIndexRoute,
  }

const WorkspaceNameEnvironmentTeamSettingsRouteRouteWithChildren =
  WorkspaceNameEnvironmentTeamSettingsRouteRoute._addFileChildren(
    WorkspaceNameEnvironmentTeamSettingsRouteRouteChildren,
  )

interface WorkspaceNameEnvironmentRouteRouteChildren {
  WorkspaceNameEnvironmentAccountSettingsRouteRoute: typeof WorkspaceNameEnvironmentAccountSettingsRouteRouteWithChildren
  WorkspaceNameEnvironmentAdminRouteRoute: typeof WorkspaceNameEnvironmentAdminRouteRouteWithChildren
  WorkspaceNameEnvironmentOrganizationSettingsRouteRoute: typeof WorkspaceNameEnvironmentOrganizationSettingsRouteRouteWithChildren
  WorkspaceNameEnvironmentTeamSettingsRouteRoute: typeof WorkspaceNameEnvironmentTeamSettingsRouteRouteWithChildren
  WorkspaceNameEnvironmentAlertHistoryRoute: typeof WorkspaceNameEnvironmentAlertHistoryRoute
  WorkspaceNameEnvironmentHomeRoute: typeof WorkspaceNameEnvironmentHomeRoute
  WorkspaceNameEnvironmentOnboardingRoute: typeof WorkspaceNameEnvironmentOnboardingRoute
  WorkspaceNameEnvironmentRunsRoute: typeof WorkspaceNameEnvironmentRunsRoute
  WorkspaceNameEnvironmentSchedulesRoute: typeof WorkspaceNameEnvironmentSchedulesRoute
  WorkspaceNameEnvironmentStorageRoute: typeof WorkspaceNameEnvironmentStorageRoute
  WorkspaceNameEnvironmentAppsIndexRoute: typeof WorkspaceNameEnvironmentAppsIndexRoute
  WorkspaceNameEnvironmentAppsNameIndexRoute: typeof WorkspaceNameEnvironmentAppsNameIndexRoute
  WorkspaceNameEnvironmentAppsNameRunsSeqRoute: typeof WorkspaceNameEnvironmentAppsNameRunsSeqRoute
}

const WorkspaceNameEnvironmentRouteRouteChildren: WorkspaceNameEnvironmentRouteRouteChildren =
  {
    WorkspaceNameEnvironmentAccountSettingsRouteRoute:
      WorkspaceNameEnvironmentAccountSettingsRouteRouteWithChildren,
    WorkspaceNameEnvironmentAdminRouteRoute:
      WorkspaceNameEnvironmentAdminRouteRouteWithChildren,
    WorkspaceNameEnvironmentOrganizationSettingsRouteRoute:
      WorkspaceNameEnvironmentOrganizationSettingsRouteRouteWithChildren,
    WorkspaceNameEnvironmentTeamSettingsRouteRoute:
      WorkspaceNameEnvironmentTeamSettingsRouteRouteWithChildren,
    WorkspaceNameEnvironmentAlertHistoryRoute:
      WorkspaceNameEnvironmentAlertHistoryRoute,
    WorkspaceNameEnvironmentHomeRoute: WorkspaceNameEnvironmentHomeRoute,
    WorkspaceNameEnvironmentOnboardingRoute:
      WorkspaceNameEnvironmentOnboardingRoute,
    WorkspaceNameEnvironmentRunsRoute: WorkspaceNameEnvironmentRunsRoute,
    WorkspaceNameEnvironmentSchedulesRoute:
      WorkspaceNameEnvironmentSchedulesRoute,
    WorkspaceNameEnvironmentStorageRoute: WorkspaceNameEnvironmentStorageRoute,
    WorkspaceNameEnvironmentAppsIndexRoute:
      WorkspaceNameEnvironmentAppsIndexRoute,
    WorkspaceNameEnvironmentAppsNameIndexRoute:
      WorkspaceNameEnvironmentAppsNameIndexRoute,
    WorkspaceNameEnvironmentAppsNameRunsSeqRoute:
      WorkspaceNameEnvironmentAppsNameRunsSeqRoute,
  }

const WorkspaceNameEnvironmentRouteRouteWithChildren =
  WorkspaceNameEnvironmentRouteRoute._addFileChildren(
    WorkspaceNameEnvironmentRouteRouteChildren,
  )

interface WorkspaceNameRouteRouteChildren {
  WorkspaceNameEnvironmentRouteRoute: typeof WorkspaceNameEnvironmentRouteRouteWithChildren
}

const WorkspaceNameRouteRouteChildren: WorkspaceNameRouteRouteChildren = {
  WorkspaceNameEnvironmentRouteRoute:
    WorkspaceNameEnvironmentRouteRouteWithChildren,
}

const WorkspaceNameRouteRouteWithChildren =
  WorkspaceNameRouteRoute._addFileChildren(WorkspaceNameRouteRouteChildren)

interface LoginDeviceRouteRouteChildren {
  LoginDeviceCompleteRoute: typeof LoginDeviceCompleteRoute
  LoginDeviceIndexRoute: typeof LoginDeviceIndexRoute
}

const LoginDeviceRouteRouteChildren: LoginDeviceRouteRouteChildren = {
  LoginDeviceCompleteRoute: LoginDeviceCompleteRoute,
  LoginDeviceIndexRoute: LoginDeviceIndexRoute,
}

const LoginDeviceRouteRouteWithChildren =
  LoginDeviceRouteRoute._addFileChildren(LoginDeviceRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  WorkspaceNameRouteRoute: WorkspaceNameRouteRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
  HomeRoute: HomeRoute,
  RegistrationClosedRoute: RegistrationClosedRoute,
  LoginDeviceRouteRoute: LoginDeviceRouteRouteWithChildren,
  AdminImpersonateRoute: AdminImpersonateRoute,
  LoginRedirectRoute: LoginRedirectRoute,
  LoginIndexRoute: LoginIndexRoute,
  RegisterIndexRoute: RegisterIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
